"use client";

import * as React from "react";
import { Plus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "What is the dress code for the evening?",
  answer: "We would love to see our guests in Black Tie Optional attire. For the ladies, floor-length gowns or sophisticated cocktail dresses, and for the gentlemen, tuxedos or dark formal suits."
}, {
  question: "Are children invited to the celebration?",
  answer: "While we love your little ones, our wedding will be an adults-only event. We hope you will enjoy a night of relaxation and celebration with us."
}, {
  question: "Is there transportation provided to the venue?",
  answer: "Yes, complimentary shuttles will depart from the designated guest hotels at 3:30 PM. Return shuttles will run every hour from 10:00 PM until the end of the reception."
}, {
  question: "Can I bring a plus one to the wedding?",
  answer: "Due to venue capacity, we are only able to accommodate those guests formally listed on your wedding invitation. We appreciate your understanding."
}, {
  question: "When should I submit my RSVP by?",
  answer: "We kindly ask that you respond by August 15th. You can easily RSVP through our website's dedicated page or by returning the card included in your invitation."
}];
export default function Faq() {
  return <section data-section-id="227279" id="important-notes" className="dark bg-background py-20">
      <div className="container mx-auto max-w-3xl px-4">
        <h2 className="font-default text-4xl font-light text-center mb-10 text-foreground tracking-tight italic">
          Important Notes
        </h2>
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-b border-border">
              <AccordionTrigger className="font-default text-[18pt] font-medium text-foreground hover:no-underline hover:bg-accent/10 transition-colors duration-300 px-4 rounded-md [&>svg:last-child]:hidden [&[data-state=open]_.plus-icon-wrapper]:rotate-45">
                <span className="text-left">{faq.question}</span>
                <span className="plus-icon-wrapper shrink-0 translate-y-0.5 transition-transform duration-500 pointer-events-none">
                  <Plus className="size-4 text-primary" />
                </span>
              </AccordionTrigger>
              <AccordionContent className="font-sans text-primary/80 text-base leading-relaxed px-4 pt-2 pb-6 tracking-wide">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}